import { Component, OnInit } from '@angular/core';
import { HomeComponent } from '../../home/home.component';
import { User } from '../../model/user.model';
import { NgForm } from '@angular/forms';
import { UserService } from '../../services/user/user.service';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  user: User;
  isLoading: boolean = false;
  isRegisterSuccess: boolean = false;
  isRegisterFailure: boolean = false;
  isEcodeFailure: boolean = false;
  errorMessages: any = [];
  isPasswordError: boolean = false;
  isEmailError: boolean = false;

  constructor(private homeComponent: HomeComponent, private userService: UserService, private router: Router) { }

  ngOnInit() {
    this.resetForm();
    this.user.emailUnavail = false;
  }


  ShowLogin() {
    this.homeComponent.showregisterscreen = false;
    this.homeComponent.showloginscreen = true;
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();
    this.user = new User;
    // this.user = {
    //   Email: '',
    //   Password: '',
    //   ConfirmPassword: '',
    //   PhoneNumber: '',
    //   Address: '',
    //   userType: '',
    //   FullName: '',
    //   VendorCode: '',
    //   type: '',
    //   IsActive: '',
    //   CreatedBy: '',
    //   CreatedOn: '',
    //   UpdatedBy: '',
    //   UpdatedOn: '',
    //   RegisterCode: '',
    //   Error: ''
    // }
  }

  OnSubmit(form: NgForm) {
    this.errorMessages = [];
    this.isLoading = true;
    this.isRegisterFailure = false;
    this.isRegisterSuccess = false;
    this.isEcodeFailure = false;
    this.isPasswordError = false;
    this.isEmailError = false;

    if (!this.user.emailUnavail) {
      if (!isNullOrUndefined(form.value.email)) {
        console.log(form.value);
        var emailregex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
        if (!form.value.email.match(emailregex)) {
          this.isEmailError = true;
          this.isLoading = false;
          return false;
        }
      }
      else {
        this.isEmailError = true;
        this.isLoading = false;
        return false;
      }
    }

    debugger;
    if (form.value.password != form.value.confirmPassword || form.value.password.length < 6) {
      this.isLoading = false;
      this.isPasswordError = true;
    }
    else {
      form.value.emailUnavail = this.user.emailUnavail;
      this.userService.registerUser(form.value)
        .subscribe((data: any) => {
          console.log(data);

          if (data == false) {
            this.isLoading = false;
            this.isRegisterFailure = true;
          }
          else if (data.error == "ecodeerror" && data.succeeded == false) {
            this.isLoading = false;
            this.isEcodeFailure = true;
          }
          else if (data.errors.length > 0 && data.succeeded == false) {
            this.errorMessages = data.errors;
            this.isLoading = false;
          }
          else if (data.errors.length == 0 && data.succeeded == true) {
            this.resetForm(form);
            this.isLoading = false;
            this.isRegisterSuccess = true;
          }
          else {
            this.isLoading = false;
            this.isRegisterFailure = true;
          }
        });
    }


  }

  checkEmail(e) {
    if (e.target.checked) {
      this.user.emailUnavail = true;

    }
    else {
      this.user.emailUnavail = false;
    }
  }
}
